__turbopack_context__.v({
  "description": "ProductsSummarySection-module-scss-module__1-wb3G__description",
  "filters": "ProductsSummarySection-module-scss-module__1-wb3G__filters",
  "heading": "ProductsSummarySection-module-scss-module__1-wb3G__heading",
  "plenty-card": "ProductsSummarySection-module-scss-module__1-wb3G__plenty-card",
  "plenty-tag": "ProductsSummarySection-module-scss-module__1-wb3G__plenty-tag",
  "products": "ProductsSummarySection-module-scss-module__1-wb3G__products",
  "products-container": "ProductsSummarySection-module-scss-module__1-wb3G__products-container",
  "round-all": "ProductsSummarySection-module-scss-module__1-wb3G__round-all",
  "shape": "ProductsSummarySection-module-scss-module__1-wb3G__shape",
  "summary-and-filters": "ProductsSummarySection-module-scss-module__1-wb3G__summary-and-filters",
  "switch": "ProductsSummarySection-module-scss-module__1-wb3G__switch",
  "switch-slider": "ProductsSummarySection-module-scss-module__1-wb3G__switch-slider",
  "tab": "ProductsSummarySection-module-scss-module__1-wb3G__tab",
  "tab-card": "ProductsSummarySection-module-scss-module__1-wb3G__tab-card",
  "tab-description": "ProductsSummarySection-module-scss-module__1-wb3G__tab-description",
  "tab-list": "ProductsSummarySection-module-scss-module__1-wb3G__tab-list",
  "tabs": "ProductsSummarySection-module-scss-module__1-wb3G__tabs",
  "title": "ProductsSummarySection-module-scss-module__1-wb3G__title",
  "toggle": "ProductsSummarySection-module-scss-module__1-wb3G__toggle",
  "toggle-option": "ProductsSummarySection-module-scss-module__1-wb3G__toggle-option",
});
